import { RouteEntity } from './route.entity';


export const LOCAL_LOGIN_URL: string = RouteEntity.Root + RouteEntity.Login;
